import React from 'react'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import { SVGIcon } from '../../../wrappers/SVGIcon';

import { useGetStudentImmigrationDocumentMedia } from '../../../../hooks/misc';

import { Icons } from '../../../../data/Assets';

import { IDocument } from '../../../../interfaces/services';

interface IViewDocumentProps {
    studentId: number;
    document: IDocument;
    onDownloadFile: (url: string) => void;
    onMinimizePreview: () => void;
}

const ViewDocument = (props: IViewDocumentProps) => {
    let { studentId, document, onDownloadFile, onMinimizePreview } = props;

    const { data: src } = useGetStudentImmigrationDocumentMedia(studentId, document.type, document.id);

    if (document?.original?.trim()?.length)
        document.original = document?.original?.split('_')[1]?.split('_')[0];


    return (
        <div className='immersion__details_form_inputs__container__preview_panel'>
            <div className='preview__file_details__container'>
                <h5 className='preview__file_name'>{document.original}</h5>

                <div className='preview__file_actions'>
                    <button className='preview__file_minimize_btn' onClick={onMinimizePreview}>
                        <SVGIcon src={Icons.Minimize} />
                    </button>
                    {src &&
                        <button className='preview__file_download_btn' onClick={() => onDownloadFile(src)}>
                            <SVGIcon src={Icons.DocDownload} />
                        </button>
                    }
                </div>
            </div>

            {src &&
                <TransformWrapper>
                    <span className=''>Scroll or expand to zoom</span>
                    <TransformComponent>
                        <img className='preview__file_image' src={src} alt={document.original} />
                    </TransformComponent>
                </TransformWrapper>
            }
        </div>
    )
}

export default ViewDocument;